module.exports = __webpack_public_path__ + "h5/img/vip0.5e5cbcd2.png";